<template>
    <div>
      <div class="module-tabs">
    <button
      v-for="tab in moduleTabs"
      :key="tab.key"
      :class="{ active: activeModule === tab.key }"
      @click="activeModule = tab.key"
    >
      {{ tab.label }}
    </button>
  </div>
        <div class="status-cards">
          <button
            type="button"
            class="status-card success status-card--clickable"
          >
            <div class="status-count">{{ currentModuleData.copied.length }} Copied</div>
            <div class="status-sub">Added successfully</div>
          </button>
          <button
            type="button"
            class="status-card skipped status-card--clickable"
          >
            <div class="status-count">{{ currentModuleData.skipped.length }} Skipped</div>
            <div class="status-sub">Skipped as the exact value exists.</div>
          </button>
          <button
            type="button"
            class="status-card revived status-card--clickable"
          >
            <div class="status-count">{{ currentModuleData?.revived.length }} Revived</div>
            <div class="status-sub">Successfully revived values.</div>
          </button>
          <div class="status-card warning">
            <div class="status-count">{{ currentModuleData?.errors.length }} Conflicts</div>
            <div class="status-sub">Need your attention</div>
          </div>
        </div>

        <div class="copy-results-content">
           <div class="status-tabs">
            <button
      :class="{ active: selectedStatus === 'copied' }"
      @click="selectStatus('copied')"
    >
      copied ({{ currentModuleData?.copied?.length }})
    </button>
    <button
      :class="{ active: selectedStatus === 'skipped' }"
      @click="selectStatus('skipped')"
    >
      Skipped ({{ currentModuleData?.skipped?.length }})
    </button>

    <button
      :class="{ active: selectedStatus === 'revived' }"
      @click="selectStatus('revived')"
    >
      Revived ({{ currentModuleData.revived.length }})
    </button>

    <button
      :class="{ active: selectedStatus === 'errors' }"
      @click="selectStatus('errors')"
    >
      Conflicts ({{ currentModuleData.errors.length }})
    </button>

  </div>
   <div class="values-container">

    <div
      v-for="(item, index) in selectedValues"
      :key="item.id || item.name || index"
      class="value-card"
    >

      <div class="value-name">
        {{ getItemName(item) }}
      </div>

      <div class="value-details">

        <span class="status-badge">
          {{ getStatusLabel(selectedStatus) }}
        </span>

        <span class="status-message">
          {{ getStatusMessage(selectedStatus, item) }}
        </span>

      </div>

    </div>
    <div
      v-if="selectedValues.length === 0"
      class="empty-state"
    >
      No {{ getStatusLabel(selectedStatus).toLowerCase() }} values found.
    </div>

  </div>

</div>
 <div class="action-row">
          <button type="button" class="btn btn-black text-xs" @click="handleClose">
            Close
          </button>
        </div>
    </div>
    </template>

<script>
export default {
  name: 'CopyTenantValuesModal',

  props: {
    migrateTenantList: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      selectedStatus: 'copied',
      activeModule: 'CUSTOM_LIST',
      moduleTabs: [
        {
          key: 'CUSTOM_LIST',
          label: 'Custom List'
        },
        {
          key: 'SEQUENCE_GENERATION',
          label: 'Sequence Generation'
        },
        {
          key: 'FORM_TEMPLATE',
          label: 'Form Template'
        },
        {
          key: 'TENANT_FEATURE_CONFIGURATION',
          label: 'Tenant Feature config'
        }
      ]
    }
  },

  computed: {
    currentModuleData () {
      const data = this.migrateTenantList?.[this.activeModule]
      return {
        copied: data?.new || [],
        skipped: data?.already_exists || [],
        revived: data?.revived || [],
        errors: data?.errors || []
      }
    },
    selectedValues () {
      return this.currentModuleData[this.selectedStatus] || []
    }
  },
  methods: {
    selectModule (module) {
      this.activeModule = module
      this.selectedStatus = 'skipped'
    },

    selectStatus (status) {
      this.selectedStatus = status
    },

    getItemName (item) {
      return (
        item.name ||
        item.source_name ||
        item.message ||
        'Unknown'
      )
    },

    getStatusLabel (status) {
      const labels = {
        copied: 'Added',
        skipped: 'Skipped',
        revived: 'Revived',
        errors: 'Error'
      }

      return labels[status] || status
    },

    getStatusMessage (status, item) {
      if (status === 'skipped') {
        return 'Exact match already exists in destination.'
      }

      if (status === 'copied') {
        return 'Added successfully.'
      }

      if (status === 'revived') {
        return 'Restored from deleted values.'
      }

      if (status === 'errors') {
        return item.message || item.error || 'Unable to migrate this value.'
      }

      return ''
    },
    handleClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>

.copy-results-content {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding-right: 4px;
}

.status-cards { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; margin-bottom: 12px; }
.status-card {
  appearance: none;
  width: 100%;
  text-align: left;
}
.status-card:disabled {
  opacity: 0.95;
  cursor: default;
}

.back-btn { border: 0; background: transparent; cursor: pointer; padding: 0; margin: 0; }
.back-btn img { width: 14px; height: 14px; }
.status-card { flex: 1; border-radius: 6px; padding: 10px; border: 1px solid; }
.status-card.success { border-color: #9ad9b0; background: #eef9f2; color: #22864b; }
.status-card.skipped { border-color: #9ec5fe; background: #eef6ff; color: #1d4ed8; }
.status-card.revived { border-color: #7fd8d1; background: #eefcfb; color: #0f766e; }
.status-card.warning { border-color: #efd08e; background: #fff8e8; color: #a86400; }
.status-card--clickable {
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;
}
.action-row { display: flex; justify-content: flex-end; gap: 8px; margin-top: 16px; }

.status-card--clickable:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(17, 24, 39, 0.08);
}
.status-card--active {
  box-shadow: 0 0 0 2px rgba(76, 91, 255, 0.12);
}
.status-count { font-size: var(--text-s); font-weight: 600; }
.status-sub { font-size: var(--text-xs1); }

.module-tabs {
  display: flex;
  gap: 8px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 20px;
}

.module-tabs button {
  border: none;
  background: transparent;
  padding: 12px 18px;
  cursor: pointer;
  color: #666;
  font-size: 14px;
}

.module-tabs button.active {
  color: #1976d2;
  border-bottom: 2px solid #1976d2;
  font-weight: 600;
}
.status-tabs {
  display: flex;
  gap: 12px;
  margin: 20px 0;
}

.status-tabs button {
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 20px;
  padding: 8px 18px;
  cursor: pointer;
  font-size: 13px;
}

.status-tabs button.active {
  background: #1976d2;
  color: #fff;
  border-color: #1976d2;
}
.values-container {
  max-height: 450px;
  overflow-y: auto;
  padding-right: 5px;
}

.value-card {
  border: 1px solid #f0c36d;
  background: #fffdf5;
  border-radius: 6px;
  padding: 10px;
  margin-bottom: 7px;
}

.value-name {
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 6px;
}

.value-details {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-badge {
  background: #fff0b8;
  color: #8a6500;
  border-radius: 3px;
  padding: 3px 7px;
  font-size: 11px;
}

.status-message {
  font-size: 11px;
  color: #666;
}

</style>
